var map = {
	"./Energy_Icon-1.png": 257,
	"./Mood_Icon-1.png": 259
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 610;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*_Icon\-1\.png$
// module id = 610
// module chunks = 0